const deployment = {
    APP_NAME: 'Mobilingo',
    PLATFORM_API_URL: 'https://api.mobilingo.ai',
    PLATFORM_API_VERSION: 'v1',
    STRIPE_API_KEY: 'pk_test_51KHlvMDqI0V60CRMmr5mNWnTqC2u90xXiuxpKou4KpoTH6CxG6mbevcGgIAUGm9xMMUOesVEMAtXDnfPHbri369M00zU24Ryxx',
    APP_DOMAIN: 'mobilingo.ai',
    FACEBOOK_PIXEL: "",
    FACEBOOK_OPTIONS: false,
    TRACKING_GDPR: false,
    //GOOGLE_ANALYTICS_ID: "G-3LZPV599W1",
    GTM_ID: "GTM-5WDD93J7",
    ENABLE_DEBUG_OVERLAY: false,
    ENCRYPTION_ENABLED: true, // Start disabled for gradual rollout (✅ tested working)
    INFLIGHT_ENCRYPTION_KEY: "fqPS9fA3f2I8MVjyATH1snqFrKXwFwsSMxW7ktcVWdk=",
};

export default deployment;
